import { render, staticRenderFns } from "./EditSpeakerTaskDialog.vue?vue&type=template&id=68d46351&"
import script from "./EditSpeakerTaskDialog.vue?vue&type=script&lang=js&"
export * from "./EditSpeakerTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports